import React from 'react';
import { AppBar, Toolbar } from '@material-ui/core';
import { Buttons } from '../button';
import { useUIContext } from '../useUIContext';

export type BarProps = {
  children?: JSX.Element[] | JSX.Element;
  forceFullWidth?: boolean;
  hideButton?: boolean;
};

export const Bar = ({ children, forceFullWidth = false, hideButton = false }: BarProps) => {
  const { menu, style, toggleMenu } = useUIContext();
  return (
    <AppBar
      position="fixed"
      className={!menu.isOpen || forceFullWidth ? style.appBar : style.appBarShift}
    >
      <Toolbar>
        {!hideButton && <Buttons.IconButton icon="menu" onClick={toggleMenu} />}
        {children}
      </Toolbar>
    </AppBar>
  );
};
